import React from "react";

/**
 * v0.4.37 D5 (operator sign-off 2026-06-04, defaults + amendments).
 *
 * Primary action CTA used for the single most-important action per
 * step (RUN CALCULATION, Proceed to Sign-Off, EXPORT XLSX, EXPORT
 * OSS XML, etc.). The styling is encapsulated here so the look-
 * and-feel stays consistent across the whole workflow without
 * forcing every consumer to re-derive className lists.
 *
 * D5A — enabled state: bg-teal-600 + shadow-lg + shadow-teal-500/10.
 * D5B — secondary callers use the bare <button> with their own
 *       border styling; this component is *primary* only.
 * D5C — disabled state: opacity-50 + cursor-not-allowed; the
 *       shadow is dropped so the disabled state doesn't look
 *       deceptively prominent.
 *
 * Operator amendment 2026-06-04: opacity-50 on the button must
 * NOT make the tooltip text unreadable. The browser-native
 * `title=` tooltip stays at 100% opacity (it renders outside the
 * button DOM), so this is naturally satisfied. The visible label
 * text inside the button is dimmed alongside the rest of the
 * button as expected.
 */
export const PrimaryCta = ({
  children, onClick, disabled, busy, testid, title,
  className = "", type = "button",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 font-bold "
    + "tracking-normal py-3 px-6 rounded-xl "
    + "bg-teal-600 text-white transition-colors";
  const enabled = "hover:bg-teal-700 shadow-lg shadow-teal-500/10";
  const off = "opacity-50 cursor-not-allowed";
  const cn = `${base} ${disabled ? off : enabled} ${className}`;
  return (
    <button
      type={type}
      data-testid={testid}
      onClick={onClick}
      disabled={disabled || busy}
      title={title}
      className={cn}
    >
      {busy ? "…" : children}
    </button>
  );
};
